import policy from '../Docs/policy.md'
import { Link } from 'react-router-dom';
import Header from '../Components/Header/Header';
const Docs = () => {
  return (
    <div className="Page">
      <Header />
      <div className="Block gap">
        <h1>Документы мероприятия</h1>
        <div className='gap'>
          <Link to="/Policy">Политика Конфиденциальности</Link>
          <Link to='/Regulation'>Положение конкурса</Link>
          <Link to='/AssetsBook'>БрендБук</Link>
            <a target="_blank" href="https://docs.google.com/document/d/16Oik64h-jvqFvQq-N3ZoO5AjPeWJuzk6r5iTZBZhD3w/edit?usp=sharing">Согласие на обработку персональных данных (очная смена)</a>
            <a target="_blank" href="https://docs.google.com/document/d/1M2VNHHlpfvtnrBEJEDsqUkin2kW5BVJrIa7qtg7rxCs/edit?usp=sharing">Согласие родителя (законного представителя) на обработку персональных данных несовершеннолетнего (очная смена)</a>
        </div>
      </div>
    </div>
  );
}
export default Docs;